module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "tabs is-centered"
  }, [_c('ul', _vm._l((_vm.socialMedia), function(social) {
    return _c('li', {
      staticClass: "social-list"
    }, [_c('a', {
      class: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-medium"
    }, [_c('i', {
      class: social.icon
    })])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ca15995!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/social-media-nav.vue
// module id = 278
// module chunks = 2